import { Tables } from "@/lib/supabase/supabase_types_override";
import { isEqual } from "lodash";
import { extractCommonQuestionProperties } from "./extractCommonQuestionProperties";
import { QuestionInstanceWasEditedChange } from "@/features/survey_sync/types/syncCheckResult";

export const checkIfOriginalWasEdited = (
  question: Tables<"question">,
  templateQuestion: Tables<"survey_bank_question_bank">,
  _surveyQuestions: Tables<"question">[]
): QuestionInstanceWasEditedChange | false => {
  const questionProperties = extractCommonQuestionProperties(question);
  const templateProperties = extractCommonQuestionProperties(templateQuestion);

  const hasChanged = !isEqual(questionProperties, templateProperties);

  if (hasChanged) {
    // Find which properties changed
    const changedProperties: Array<{
      property: string;
      instanceValue: unknown;
      templateValue: unknown;
    }> = [];

    Object.keys(templateProperties).forEach(key => {
      const templateValue = (templateProperties as any)[key];
      const instanceValue = (questionProperties as any)[key];

      if (!isEqual(templateValue, instanceValue)) {
        changedProperties.push({
          property: key,
          instanceValue,
          templateValue,
        });
      }
    });

    return {
      type: "QUESTION_WAS_EDITED",
      context: {
        changedProperties,
      },
    };
  }

  return false;
};